import { PaginationListViewModelImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/verticallist/paginationverticallist/paginationlistviewmodel';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import * as React from 'react';
import { BlackListRowComponent } from './blacklistrowcomponent';
import { MemberDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto';

export class BlackListViewModelImpl extends PaginationListViewModelImpl<MemberDetailsDto>
{
    constructor(position:number,context: BaseContext, private onDelete: any)
    {
        super(position,context);
        this.onDeleteClick = this.onDeleteClick.bind(this);

    }

    getView(t: MemberDetailsDto, position: number): boolean | JSX.Element 
    {
        return <BlackListRowComponent  onDeleteClick={this.onDeleteClick} key={position}  context={this.getContext()} blacklistDto={t}  position={position}/>;
    }

    onDeleteClick(memberdetailsdto:MemberDetailsDto):void
    {
         this.onDelete(memberdetailsdto);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/blacklisting/viewmodel/blacklistviewmodel.tsx